import React, { useEffect, useRef, useState } from "react";
import {
    createEnvelopeRecipient,
    getCountryByOrder,
    getCountryList,
    updateRecipient,
} from "../../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../../utils";
import validator from "validator";
import { COUNTRY_CODE, COUNTRY_ICON, COUNTRY_ID } from "../../../../configs/AppConfig";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { CustomInput, CustomSelect } from "../../../../components"
function EnvelopeRecipients(props) {

    const [countryList, setCountryList] = useState([]);
    const [countryCodeList, setCountryCodeList] = useState([]);
    const [id, setId] = useState(0);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [countryId, setCountryId] = useState(COUNTRY_ID);
    const [countryCode, setCountryCode] = useState(COUNTRY_CODE);
    const [mobile, setMobile] = useState("");
    const [countryIcon, setCountryIcon] = useState(COUNTRY_ICON);
    const [companyName, setCompanyName] = useState("");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [addressCountryId, setAddressCountryId] = useState("");
    const [zipcode, setZipcode] = useState("");
    const [documentIds, setDocumentIds] = useState([]);
    const [documentOptions, setDocumentOptions] = useState([]);
    const [formIds, setFormIds] = useState([]);
    const [formOptions, setFormOptions] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const animatedComponents = makeAnimated();
    const countryDropdownRef = useRef(null);
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);

    const toggleAccordion = () => {
        setIsAccordionOpen(!isAccordionOpen);
    };

    useEffect(() => {
        getCountryByOrder("code")
            .then((response) => setCountryCodeList(response.data.data))
            .catch(() => { });

        getCountryList()
            .then((response) => setCountryList(response.data.data))
            .catch(() => { });
    }, []);

    useEffect(() => {
        if (props?.formObj?.documents?.length > 0) {
            let options = props.formObj.documents.map((d) => ({
                value: d.id,
                label: d.name,
            }));
            setDocumentOptions(options);
            setDocumentIds(options);
        }

        if (props?.formObj?.fill_forms?.length > 0) {
            let options = props.formObj.fill_forms.map((d) => ({
                value: d.id,
                label: d.name,
            }));
            setFormOptions(options);
            setFormIds(options);
        }
    }, [props?.formObj]);

    useEffect(() => {
        setId(props?.recipData?.id || 0);
        setFirstName(props?.recipData?.first_name || "");
        setLastName(props?.recipData?.last_name || "");
        setEmail(props?.recipData?.email || "");
        setMobile(props?.recipData?.mobile || "");
        setCountryId(props?.recipData?.country_id || COUNTRY_ID);

        if (props?.recipData?.country_id) {
            let index = countryList.findIndex(
                (x) => x.id === parseInt(props?.recipData?.country_id)
            );
            if (index > -1) {
                setCountryIcon(countryList[index]["icon"].toLowerCase());
                setCountryCode(countryList[index]["code"]);
            }
        }

        setCompanyName(props?.recipData?.company_name || "");
        setAddress1(props?.recipData?.address_1 || "");
        setAddress2(props?.recipData?.address_2 || "");
        setCity(props?.recipData?.city || "");
        setState(props?.recipData?.state || "");
        setAddressCountryId(props?.recipData?.address_country_id || "");
        setZipcode(props?.recipData?.zip_code || "");
    }, [props?.recipData, countryList]);

    let errorsObj = {
        first_name: "",
        last_name: "",
        email: "",
        mobile: "",
        document: "",
        data_enter: "",
    };
    const [errors, setErrors] = useState(errorsObj);

    const clsButtonRef = useRef(null);

    const filteredCountries = countryCodeList.filter(
        (country) =>
            country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            country.code.toString().includes(searchTerm)
    );

    function handleCountry(e, obj) {
        e.preventDefault();
        let id = obj.id;
        let index = countryCodeList.findIndex((x) => x.id === parseInt(id));
        if (index > -1) {
            setCountryIcon(countryCodeList[index]["icon"].toLowerCase());
        }
        setCountryId(id);
        setCountryCode(obj.code);
        setSearchTerm("");
        if (countryDropdownRef.current) countryDropdownRef.current.scrollTop = 0;
    }

    function onStoreRecipient(e, type) {
        e.preventDefault();
        let error = false;
        let errorObj = { ...errorsObj };

        if (!firstName) {
            errorObj.first_name = "First name must be required";
            error = true;
        }
        if (!lastName) {
            errorObj.last_name = "Last name must be required";
            error = true;
        }
        if (!email) {
            errorObj.email = "Email must be required";
            error = true;
        } else if (!validator.isEmail(email)) {
            errorObj.email = "Invalid email";
            error = true;
        }

        // Mobile validation
        if (mobile && mobile.length !== 10) {
            errorObj.mobile = "Mobile number must be 10 digits";
            error = true;
        }

        if (props?.formObj?.documents.length > 0 && documentIds.length === 0) {
            errorObj.document = "Please select document";
            error = true;
        }

        if (props?.formObj?.fill_forms.length > 0 && formIds.length === 0) {
            errorObj.data_enter = "Please select form";
            error = true;
        }

        setErrors(errorObj);
        if (error) return;

        const formData = { ...props.formObj };

        let obj = {
            envelope_id: formData.envelope_id,
            first_name: firstName,
            last_name: lastName,
            email: email,
            country_id: countryId,
            mobile: mobile,
            company_name: companyName,
            address_1: address1,
            address_2: address2,
            city: city,
            state: state,
            zip_code: zipcode,
            address_country_id: addressCountryId,
        };

        let index = formData.recipient_List.findIndex((x) => x.email === obj.email);
        if (index === -1) {
            props.setLoading(true);
            createEnvelopeRecipient(obj)
                .then((response) => {
                    let recipientData = response.data.data;
                    formData.recipient_List.push(recipientData);

                    let firstLetter = firstName.charAt(0);
                    let lastLetter = lastName.charAt(0);
                    let recipientDisplayName = [firstLetter + lastLetter];
                    if (documentIds.length > 0) {
                        for (let i = 0; i < formData.documents.length; i++) {
                            let index = documentIds.findIndex(
                                (x) => parseInt(x.value) === parseInt(formData.documents[i]["id"])
                            );
                            if (index > -1) {
                                let requestIds = formData.documents[i]["request_id"].toString().split(",");
                                if (requestIds.findIndex((x) => parseInt(x) === 0) === -1) {
                                    formData.documents[i]["request_id"] =
                                        formData.documents[i]["request_id"] + "," + recipientData.id;
                                    let displayNameList = formData.documents[i]["request_display"];
                                    for (let j = 0; j < recipientDisplayName.length; j++) {
                                        displayNameList.push(recipientDisplayName[j]);
                                    }
                                    formData.documents[i]["request_display"] = displayNameList;
                                }
                            }
                        }
                    }

                    if (formIds.length > 0) {
                        for (let i = 0; i < formData.fill_forms.length; i++) {
                            let index = formIds.findIndex(
                                (x) => parseInt(x.value) === parseInt(formData.fill_forms[i]["id"])
                            );
                            if (index > -1) {
                                let requestIds = formData.fill_forms[i]["request_id"].toString().split(",");
                                if (requestIds.findIndex((x) => parseInt(x) === 0) === -1) {
                                    formData.fill_forms[i]["request_id"] =
                                        formData.fill_forms[i]["request_id"] + "," + recipientData.id;
                                    let displayNameList = formData.fill_forms[i]["request_display"];
                                    for (let j = 0; j < recipientDisplayName.length; j++) {
                                        displayNameList.push(recipientDisplayName[j]);
                                    }
                                    formData.fill_forms[i]["request_display"] = displayNameList;
                                }
                            }
                        }
                    }

                    props.setFormObj(formData);
                    if (type === 1) {
                        clsButtonRef.current?.click();
                        clearRecipientForm();
                    } else {
                        clearRecipientForm();
                    }
                    props.setLoading(false);
                })
                .catch((err) => {
                    props.setLoading(false);
                    toast.error(Utils.getErrorMessage(err));
                });
        } else {
            toast.error("Recipient already exist.");
        }
    }

    function onSaveRecipient(e) {
        e.preventDefault();
        onStoreRecipient(e, 1);
    }

    function onSaveAddRecipient(e) {
        e.preventDefault();
        onStoreRecipient(e, 2);
    }

    function onUpdateRecipient(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };

        if (!firstName) {
            errorObj.first_name = "First name must be required";
            error = true;
        }
        if (!lastName) {
            errorObj.last_name = "Last name must be required";
            error = true;
        }
        if (!email) {
            errorObj.email = "Email must be required";
            error = true;
        } else if (!validator.isEmail(email)) {
            errorObj.email = "Please enter valid email address";
            error = true;
        }

        // Mobile validation
        if (mobile && mobile.length !== 10) {
            errorObj.mobile = "Mobile number must be 10 digits";
            error = true;
        }

        setErrors(errorObj);

        if (error) return;

        let obj = {
            recipient_id: id,
            first_name: firstName,
            last_name: lastName,
            email: email,
            country_id: countryId,
            mobile: mobile,
            company_name: companyName,
            address_1: address1,
            address_2: address2,
            city: city,
            state: state,
            zip_code: zipcode,
            address_country_id: addressCountryId,
        };
        props.setLoading(true);
        updateRecipient(obj)
            .then((response) => {
                const formData = { ...props.formObj };
                let index = formData.recipient_List.findIndex((x) => x.id === id);
                if (index > -1) {
                    formData.recipient_List[index]["first_name"] = firstName;
                    formData.recipient_List[index]["last_name"] = lastName;
                    formData.recipient_List[index]["email"] = email;
                    formData.recipient_List[index]["country_id"] = countryId;
                    formData.recipient_List[index]["country_codeLarge"] = countryCode;
                    formData.recipient_List[index]["mobile"] = mobile;
                    formData.recipient_List[index]["company_name"] = companyName;
                    formData.recipient_List[index]["address_1"] = address1;
                    formData.recipient_List[index]["address_2"] = address2;
                    formData.recipient_List[index]["city"] = city;
                    formData.recipient_List[index]["state"] = state;
                    formData.recipient_List[index]["zip_code"] = zipcode;
                    formData.recipient_List[index]["address_country_id"] = addressCountryId;
                    props.setFormObj(formData);
                }
                toast.success(response.data.message);
                clsButtonRef.current?.click();
                clearRecipientForm();
                props.setLoading(false);
            })
            .catch((err) => {
                props.setLoading(false);
                toast.error(Utils.getErrorMessage(err));
            });
    }

    function onCloseRecipient() {
        clsButtonRef.current?.click();
        clearRecipientForm();
    }

    function clearRecipientForm() {
        setId(0);
        setFirstName("");
        setLastName("");
        setEmail("");
        setMobile("");
        setCountryId(COUNTRY_ID);
        setCountryCode(COUNTRY_CODE);
        setCountryIcon(COUNTRY_ICON);
        setCompanyName("");
        setAddress1("");
        setAddress2("");
        setCity("");
        setState("");
        setAddressCountryId("");
        setZipcode("");
        setDocumentIds([]);
        setFormIds([]);
        setSearchTerm("");
        let errorObj = {
            first_name: "",
            last_name: "",
            email: "",
            mobile: "",
            document: "",
            data_enter: "",
        };
        setErrors(errorObj);
    }

    return (
        <div
            className="offcanvas offcanvas-end recipients-offcanvas"
            data-bs-scroll="true"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            id="addRecipients"
            aria-labelledby="addRecipientsLabel"
        >
            <div className="offcanvas-header">
                <h5>{id ? "Edit" : "Add"} Collaborator</h5>
                <button ref={clsButtonRef} className="btn close_btn" data-bs-dismiss="offcanvas">
                    <i className="bi bi-x-circle" />
                </button>
            </div>

            <div className="offcanvas-body">
                <div className="row g-3">
                    <div className="col-lg-6 ">
                        <CustomInput
                            label="First Name"
                            name="first_name"
                            placeholder="Enter First Name"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            error={errors.first_name}
                            required
                        />
                    </div>

                    <div className="col-lg-6">
                        <CustomInput
                            label="Last Name"
                            name="last_name"
                            placeholder="Enter Last Name"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            error={errors.last_name}
                            required
                        />
                    </div>

                    <div className="col-lg-6">
                        <CustomInput
                            label="Email"
                            name="email"
                            placeholder="Enter Email Address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value.trim().trim())}
                            error={errors.email}
                            required
                        />
                    </div>

                    {/* MOBILE */}
                    <div className="col-lg-6">
                        <label className="form-label custom-input-label">Mobile Number</label>
                        <div className="mobile-input-group">
                            <div className="dropdown">
                                <button
                                    className="country-code-btn dropdown-toggle"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <div className="d-flex align-items-center">
                                        <img
                                            src={`/images/flags/${countryIcon}.png`}
                                            className="me-2"
                                            width="20"
                                            alt="flag"
                                        />
                                        <span>+{countryCode}</span>
                                    </div>
                                </button>
                                <ul
                                    className="dropdown-menu p-2 country_code-dropdown"
                                    ref={countryDropdownRef}
                                >
                                    <li className="mb-2">
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="Search"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </li>

                                    {filteredCountries.map((item, idx) => (
                                        <li key={idx} onClick={(e) => handleCountry(e, item)}>
                                            <div className="dropdown-item d-flex align-items-center">
                                                <img
                                                    src={`/images/flags/${item.icon}.png`}
                                                    width="20"
                                                    className="me-2"
                                                    alt={item.name}
                                                />
                                                {item.name}
                                                <span className="ms-auto">+{item.code}</span>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <input
                                type="tel"
                                className="form-control"
                                value={mobile}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, '');
                                    setMobile(value);
                                    if (errors.mobile && value.length === 10) {
                                        setErrors(prev => ({ ...prev, mobile: "" }));
                                    }
                                }}
                                onBlur={() => {
                                    if (mobile && mobile.length !== 10) {
                                        setErrors(prev => ({ ...prev, mobile: "Mobile number must be 10 digits" }));
                                    }
                                }}
                                placeholder="Mobile Number"
                                maxLength={10}
                            />
                        </div>
                        {errors.mobile && <div className="text-danger mt-1">{errors.mobile}</div>}
                    </div>
                </div>

                {/* MORE DETAILS */}
                <div className="custom-accordion mt-4">
                    <div
                        className="custom-accordion-header"
                        onClick={toggleAccordion}
                    >
                        <span>More Details</span>
                        <i className={`bi ${isAccordionOpen ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
                    </div>

                    {isAccordionOpen && (
                        <div className="custom-accordion-body">
                            <div className="row g-3">
                                <div className="col-lg-6">
                                    <CustomInput
                                        label="Company Name"
                                        name="company_name"
                                        placeholder="Enter Company Name"
                                        value={companyName}
                                        onChange={(e) => setCompanyName(e.target.value)}
                                        error={errors.company_name}
                                    />
                                </div>
                                <div className="col-lg-12">
                                    <CustomInput
                                        label="Address Line 1"
                                        name="address_1"
                                        placeholder="Address line 1"
                                        value={address1}
                                        onChange={(e) => setAddress1(e.target.value)}
                                        error={errors.address_1}
                                    />
                                </div>
                                <div className="col-lg-12">
                                    <CustomInput
                                        label="Address Line 2"
                                        name="address_2"
                                        placeholder="Address line 2"
                                        value={address2}
                                        onChange={(e) => setAddress2(e.target.value)}
                                        error={errors.address_2}
                                    />
                                </div>

                                <div className="col-lg-6">
                                    <CustomInput
                                        label="City"
                                        name="city"
                                        placeholder="City"
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)}
                                        error={errors.city}
                                    />
                                </div>

                                <div className="col-lg-6">
                                    <CustomInput
                                        label="State"
                                        name="state"
                                        placeholder="State"
                                        value={state}
                                        onChange={(e) => setState(e.target.value)}
                                        error={errors.state}
                                    />
                                </div>

                                <div className="col-lg-6">
                                    <label className="form-label custom-input-label">Country</label>
                                    <select
                                        className="form-select"
                                        value={addressCountryId}
                                        onChange={(e) => setAddressCountryId(e.target.value)}
                                    >
                                        <option value="">Country</option>
                                        {countryList.map((c) => (
                                            <option key={c.id} value={c.id}>
                                                {c.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-lg-6">
                                    <CustomInput
                                        label="Zipcode"
                                        name="zipcode"
                                        type="number"
                                        placeholder="Zipcode"
                                        value={zipcode}
                                        onChange={(e) => setZipcode(e.target.value)}
                                        error={errors.zipcode}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* DOCUMENTS & FORMS (unchanged react-select) */}
                {/* <div className="row mx-lg-2">
                    {documentOptions.length > 0 && (
                        <div className="col-md-12">
                            <label className="form-label mb-2">Add Request Documents</label>
                            <Select
                                closeMenuOnSelect={true}
                                value={documentIds}
                                components={animatedComponents}
                                isMulti
                                onChange={(e) => setDocumentIds(e)}
                                options={documentOptions}
                                classNamePrefix="custom-select"
                            />
                            {errors.document && <div className="text-danger">{errors.document}</div>}
                        </div>
                    )}

                    {formOptions.length > 0 && (
                        <div className="col-md-12 mb-5">
                            <label className="form-label mb-2">Add Request Data</label>
                            <Select
                                closeMenuOnSelect={true}
                                value={formIds}
                                components={animatedComponents}
                                isMulti
                                onChange={(e) => setFormIds(e)}
                                options={formOptions}
                                classNamePrefix="custom-select"
                            />
                            {errors.data_enter && (
                                <div className="text-danger">{errors.data_enter}</div>
                            )}
                        </div>
                    )}
                </div> */}

                {/* FOOTER BUTTONS */}
                <div className="modal-footer py-2 border-top gap-3">
                    <button type="button" onClick={onCloseRecipient} className="btn-outline-secondary">
                        Cancel
                    </button>

                    {id ? (
                        <button type="button" onClick={onUpdateRecipient} className="btn-primary">
                            Update
                        </button>
                    ) : (
                        <>
                            <button
                                type="button"
                                onClick={(e) => onStoreRecipient(e, 2)}
                                className="btn-outline-primary"
                            >
                                Save & Add Another
                            </button>

                            <button
                                type="button"
                                onClick={(e) => onStoreRecipient(e, 1)}
                                className="btn-primary"
                            >
                                Save
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default EnvelopeRecipients;
